import { FormField, InputData, OutputRow } from '../interfaces/AppProps';

const generateRows = (
  inputEntryFormFields: InputData,
  outputEntryFormFields: FormField[],
): OutputRow[] => {

  const headers = inputEntryFormFields.map((item: any) => item.name);
  const ranges = inputEntryFormFields.map((item: any) => {
    let values: string[] = [];
    if (item?.type === 'string') {
      if (item.start.includes(',') && item.includeStart === true) {
        const commaSeparatedValues = item.start
          .split(',')
          .map((value: any) => value.trim());
        commaSeparatedValues.forEach((value: any) => values.push(value));
      } else {
        values.push(item.start);
      }
    } else {
      let start = item.start ? parseFloat(item.start) : 0;
      let end = item.end ? parseFloat(item.end) : 0;
      let interval = item.interval ? parseFloat(item.interval) : 1;
      
      // Calculate the actual last value that fits within the range
      let lastValue = start;
      while (lastValue + interval <= end) {
        lastValue += interval;
      }
      
      for (let i = start; i <= lastValue; i += interval) {
        if (values.length === 0) {
          if (item.includeStart === true) {
            values.push('<=' + ' ' + i.toFixed(2));
          } else {
            values.push('<' + ' ' + i.toFixed(2));
          }
        } else {
          if (item.includeStart) {
            values.push(`] ${(i - interval).toFixed(2)} to  ${i.toFixed(2)} ]`);
          } else {
            values.push(`[ ${(i - interval).toFixed(2)} to  ${i.toFixed(2)} [`);
          }
        }
      }
      
      // Add the final condition for values >= lastValue (or > lastValue)
      if (lastValue === end) {
        // If we exactly reached the end
        if (item.includeStart) {
          values.push('>' + ' ' + end.toFixed(2));
        } else {
          values.push('>=' + ' ' + end.toFixed(2));
        }
      } else {
        // If we stopped before reaching the end, add condition for >= lastValue
        if (item.includeStart) {
          values.push('>=' + ' ' + lastValue.toFixed(2));
        } else {
          values.push('>' + ' ' + lastValue.toFixed(2));
        }
      }
    }
    console.log(values, 'values');
    return values;
  });

  let result: OutputRow[] = [];

  function combine(index: number, current: OutputRow) {
    if (index === ranges.length) {
      result.push({ ...current });
      return;
    }
    for (let i = 0; i < ranges[index].length; i++) {
      let newEntry = { ...current };
      if (
        typeof ranges[index][i] === 'string' 
      ) {
        if (ranges[index][i].includes(',')) {
          const commaSeparatedValues = ranges[index][i]
            .split(',')
            .map((value) => `"${value.trim()}"`)
            .join(',');
          newEntry[headers[index]] = commaSeparatedValues;
        } else {
          newEntry[headers[index]] = `"${ranges[index][i]}"`;
        }
      } else {  
        if (ranges[index][i].includes(',')) {
          const commaSeparatedValues = ranges[index][i]
            .split(',')
            .map((value) => `"${value.trim()}"`)
            .join(',');
          newEntry[headers[index]] = commaSeparatedValues;
        } else {
          newEntry[headers[index]] = ranges[index][i];
        }
      }

      combine(index + 1, newEntry);
    }
  }
  combine(0, {});
  console.log(result, 'result');
  
  if (result.length > 0) {
    result.push(
      Object.keys(result[0]).reduce((acc: any, key) => {
        acc[key] = ' ';
        return acc;
      }, {})
    );
  }
  
  const withOutputResult = result.map((item) => {
    const dynamicOutput = outputEntryFormFields.reduce(
      (acc: any, field: any) => {
        acc[field.name] = '';
        return acc;
      },
      {}
    );
    return {
      ...item,
      ...dynamicOutput,
    };
  });
  return withOutputResult;
}

export default generateRows